export const ShippingStatus = Object.freeze({
	Zorbit: 'Zorbit',
	Self: 'Self',
});

export const InboundStatus = Object.freeze({
	Draft: 'Draft',
	Submitted: 'Submitted',
	InTransit: 'In Transit',
	PartiallyArrived: 'Partially Arrived',
	Arrived: 'Arrived',
	Processing: 'Processing',
	Completed: 'Completed',
	ActionRequired: 'Action Required',
	Cancelled: 'Cancelled',
	AllInbounds: 'All Inbounds',
});

export const WarehouseStatus = Object.freeze({
	Active: 'Active',
	Inactive: 'Inactive',
});
